import htmx from "htmx.org";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";

window.htmx = htmx;
window.Alpine = Alpine;

Alpine.plugin(focus);
Alpine.start();

document.addEventListener("DOMContentLoaded", () => {
    // Toggle is-stuck css class to sticky elements when they are stuck
    for (const elem of document.querySelectorAll(".sticky-top, .sticky-bottom")) {
        const observer = new IntersectionObserver(
            ([e]) => e.target.classList.toggle("is-stuck", e.intersectionRatio < 1),
            { threshold: [1] },
        );

        observer.observe(elem);
    }
});

function parentElement(el, selector) {
    // Get the parent element of an element that matches a selector
    const parentEl = el.parentElement;
    if (!parentEl) return null;
    if (!selector) return parentEl;
    if (parentEl.matches(selector)) return parentEl;
    return parentElement(parentEl, selector);
}
window.parentElement = parentElement;
